import React from "react";
import constants from "../../constants";
import { Link } from "@reach/router";
import moment from "moment";
import simboloBlanco from "../../assets/rebrand/simbolo-blanco.png";

const socialLinks = [
  {
    href: "https://www.facebook.com/thebodymethodmx",
    icon: "fab fa-facebook",
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/thebodymethodmx/",
    icon: "fab fa-instagram",
    label: "Instagram",
  },
  {
    href: "https://www.tiktok.com/@thebodymethodmx/",
    icon: "fab fa-tiktok",
    label: "TikTok",
  },
];

const Footer = () => {
  return (
    <div className="tbm-site-footer container-fluid bg-dark py-4 px-md-5 px-4 text-white">
      <div className="row border-bottom pb-3 mb-3">
        <div className="col-12 col-md-8 px-0">
          <div className="d-flex align-items-center gap-2 gap-md-3 flex-wrap">
            <img
              src={simboloBlanco}
              alt=""
              width={40}
              height={40}
              className="flex-shrink-0"
              style={{ objectFit: "contain" }}
            />
            <h5 className="mb-0">Move, Transform, Lead</h5>
          </div>
        </div>
        <div className="col-12 col-md-4 px-0 text-end mt-3 mt-md-0">
          <div>
            <Link to="/ubicacion" className="text-white no-decoration">
              Ubicación y Contacto
            </Link>
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mt-2">
            {socialLinks.map(({ href, icon, label }) => (
              <a
                key={href}
                href={href}
                className="no-decoration text-white"
                rel="noreferrer"
                target="_blank"
                aria-label={label}
              >
                <i className={`${icon} footer-icon`} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 px-0 mobile-left small mb-2">
          <Link
            to="/terminos"
            className="text-white d-md-inline-block d-block m-2 no-decoration"
          >
            Términos y condiciones
          </Link>
          <Link
            to="/terminos"
            className="text-white m-2 no-decoration d-md-inline-block d-block"
          >
            Política de privacidad
          </Link>
          <Link
            to="/preguntas-frecuentes"
            className="text-white m-2 no-decoration d-md-inline-block d-block"
          >
            Preguntas frecuentes
          </Link>
        </div>
        <div className="col-12 col-md-6 px-0 text-end mobile-center my-2">
          <span>
            &copy; {moment().year()} {constants.business_name}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
